import { appendSnsBtns } from "../functions/sns";
import triggerEcommerceTracking from "../functions/triggerEcommerceTracking";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.columns.show").length) return;
  appendSnsBtns();
  triggerEcommerceTracking("gtmColumnRelatedArticles");
});
